<template>
  <div style="height: calc(100% + 120px)">
    <SummaryBarChart :data="data.data || []" title="commission" label="commission" key="comission" />
  </div>
</template>

<script>
import SummaryBarChart from '@/components/smartDashboard/SummaryBarChart.vue';

export default {
  name: 'BarChartCard',
  components: {
    SummaryBarChart
  },
  props: {
    data: {
      type: Object,
      default: () => ({ data: [] })
    }
  }
};
</script>

<style></style>
